var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-custom-scrollbar',{staticClass:"slide-main effect-transition-fast",attrs:{"id":"slide_wrap","settings":{maxScrollbarLength: 300}}},[_c('canvas',{attrs:{"id":"slide_main"}})])}
var staticRenderFns = []

export { render, staticRenderFns }